import { cn } from '@/lib/utils'

type ContentContainerProps = {
  children: React.ReactNode
  size?: 'default' | 'wide' | 'narrow'
  className?: string
  id?: string
}

/**
 * ContentContainer provides consistent max-width constraints across pages.
 * 
 * Sizes:
 * - default: max-w-3xl (768px) — results, dashboard, interior pages
 * - wide: max-w-4xl (896px) — landing page, marketing
 * - narrow: max-w-lg (512px) — auth, onboarding forms
 */
export function ContentContainer({
  children,
  size = 'default',
  className,
  id,
}: ContentContainerProps) {
  const sizeClasses = {
    default: 'max-w-3xl',
    wide: 'max-w-4xl',
    narrow: 'max-w-lg',
  }

  return (
    <div id={id} className={cn('mx-auto px-4 sm:px-6 w-full', sizeClasses[size], className)}>
      {children}
    </div>
  )
}
